export type AssetBaseEvent = typeof ASSET_BASE_EVENT;

export const ASSET_BASE_EVENT = `asset:next`;

export const ASSET_EVENT = <const>{
	CHECKIN: `${ASSET_BASE_EVENT}:checkin`,
	CHECKOUT: `${ASSET_BASE_EVENT}:checkout`,

	DELETE: `${ASSET_BASE_EVENT}:delete`,
	DELETE_ERROR: `${ASSET_BASE_EVENT}:delete:error`,
	DELETE_SUCCESS: `${ASSET_BASE_EVENT}:delete:success`,

	CREATE_PDF: `${ASSET_BASE_EVENT}:share:createPDF`,
	CREATE_PDF_DOWNLOAD: `${ASSET_BASE_EVENT}:share:createPDF:download`,
	CREATE_PDF_SHARE_LINK: `${ASSET_BASE_EVENT}:share:createPDF:link`,
	DOWNLOAD: `${ASSET_BASE_EVENT}:share:download`,
	LOCK: `${ASSET_BASE_EVENT}:lock`,
	MENU: `${ASSET_BASE_EVENT}:share:menu`,
	SHARE_LINK: `${ASSET_BASE_EVENT}:share:link`,
	SHARE_EMBED_LINK: `${ASSET_BASE_EVENT}:share:embedLink`,
	SHARE_PUBLISH: `${ASSET_BASE_EVENT}:share:publish`,
	SHARE_PUBLISH_BRIGHTCOVE: `${ASSET_BASE_EVENT}:share:publish:brightcove`,
	SHARE_PUBLISH_YOUTUBE: `${ASSET_BASE_EVENT}:share:publish:youtube`,

	REIMPORT: `${ASSET_BASE_EVENT}:reimport`,
	RESYNC: `${ASSET_BASE_EVENT}:resync`,

	UNLOCK: `${ASSET_BASE_EVENT}:unlock`,

	MAKE_VISIBLE: `${ASSET_BASE_EVENT}:makeVisible`,
	MAKE_NOT_VISIBLE: `${ASSET_BASE_EVENT}:makeNotVisible`,
};
